import angular from 'angular';

module.exports = angular.module('market.models.listing-interest', [])
.factory('ListingInterest', function($resource) {
  return $resource('/api/v1/listings/:listing_slug/interests/:id', {
    id: '@id',
    listing_slug: '@listing_slug'
  }, {
    update: {
      method: 'PUT',
    },
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/listing-interest.js
 **/